



























// OBSOLETE
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Candidate from '@/evaluations/entities/candidate'

@Component
export default class CandidateList extends Vue {
  @Prop({ type: Boolean, default: false })
  public loading!: boolean

  @Prop({ default: () => [] })
  public items!: Candidate[]

  private get headers() {
    return [
      {
        text: this.$tc('common.name.full'),
        value: 'firstName',
        sortable: false,
      },
      {
        text: '',
        value: 'action',
        sortable: false,
        cellClass: 'table-actions',
        align: 'end',
      },
    ]
  }

  private rate(item: Candidate) {
    this.$emit('rate', item)
  }
}
